import { savedOrderListFilterStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListFilter";
import { FormInputWrapper } from "@insite/mobius/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

savedOrderListFilterStyles.orderTotalAmountTextField = {
    cssOverrides: {
        formInputWrapper: css`
            margin-top: 32px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 34px;
                    `,
                    css`
                        margin-top: 34px;
                    `,
                    css`
                        margin-top: 34px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
};

savedOrderListFilterStyles.container = {
    css: css`
        padding-bottom: 15px;
        > ${GridOffset} {
            margin: auto;
            width: 100%;
        }
    `,
};
savedOrderListFilterStyles.headingGridItem = {
    width: 12,
    css: css`
        padding: 10px;
        background: ${getColor("secondary")};
    `,
};
savedOrderListFilterStyles.datesGridItem = {
    width: [12, 12, 12, 12, 4],
    css: css`
        padding: 15px;
        ${GridItemStyle} {
            width: 100%;
            > div {
                width: 100%;
                ${FormInputWrapper} {
                    margin-top: 6px !important;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            null,
                            null,
                            css`
                                margin-top: 7px !important;
                            `,
                        ])}

                    div[class^="react-datetime-picker__wrapper"] {
                        height: 40px !important;
                    }
                }
            }
        }
    `,
};
savedOrderListFilterStyles.buttonsItem = {
    width: [12, 12, 12, 3, 4],
    css: css`
        justify-content: flex-end;
        align-items: flex-end;
    `,
};
savedOrderListFilterStyles.fromGridItem = {
    width: [12, 12, 6, 6, 6],
};
savedOrderListFilterStyles.toGridItem = {
    width: [12, 12, 6, 6, 6],
};
savedOrderListFilterStyles.orderTotalGridItem = {
    css: css`
        padding: 15px;
    `,
    width: [12, 12, 12, 12, 4],
};
